import { MarkType, ModelType, YearCurrentType, ModificationType } from '@entities/Auto';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fieldsAuto, filterActions, FilterParams, getAuto, getParams } from '@entities/Filter';

export type useSaveAutoParamsProps = {
  mark: MarkType;
  model: ModelType;
  year: YearCurrentType;
  modification: ModificationType;
};

export enum LocalStorageKeyAutoParam {
  Mark = 'mark',
  Model = 'model',
  Year = 'year',
  Modification = 'modification',
}

export const keyFilterLocalStorage = 'filter_auto_save_values';

export const useSaveAutoParams = () => {
  const { mark: markCurrent, model: modelCurrent, year: yearCurrent, modification: modificationCurrent } = useAppSelector(getAuto);
  const params = useAppSelector(getParams);
  const [paramAuto, setParamAuto] = useState<useSaveAutoParamsProps>({
    mark: null,
    model: null,
    year: null,
    modification: null,
  });

  const dispatch = useAppDispatch();
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const handlerGetParamsLocalStorage = (key, type) => {
    const value = window.localStorage.getItem(key);
    return type === 'json' ? JSON.parse(value) : value;
  };

  const handlerSetParamsLocalStorage = (key, value) => {
    window.localStorage.setItem(key, JSON.stringify(value) || null);
  };

  const handlerClearParamsLocalStorage = () => {
    window.localStorage.removeItem(keyFilterLocalStorage);
  };

  useEffect(() => {
    if (!isLoaded) {
      const valuesAutoStorage = handlerGetParamsLocalStorage(keyFilterLocalStorage, 'json');
      setParamAuto(valuesAutoStorage);
      if (
        valuesAutoStorage &&
        !params[FilterParams.MarkAuto] &&
        !params[FilterParams.ModelAuto] &&
        !params[FilterParams.YearAuto] &&
        !params[FilterParams.ModificationAuto]
      ) {
        dispatch(
          filterActions.setAuto({
            key: fieldsAuto.Mark,
            value: params[FilterParams.MarkAuto] || valuesAutoStorage[fieldsAuto.Mark],
          }),
        );
        dispatch(
          filterActions.setAuto({
            key: fieldsAuto.Model,
            value: params[FilterParams.ModelAuto] || valuesAutoStorage[fieldsAuto.Model],
          }),
        );
        dispatch(
          filterActions.setAuto({
            key: fieldsAuto.Year,
            value: params[FilterParams.YearAuto] || valuesAutoStorage[fieldsAuto.Year],
          }),
        );
        dispatch(
          filterActions.setAuto({
            key: fieldsAuto.Modification,
            value: params[FilterParams.ModificationAuto] || valuesAutoStorage[fieldsAuto.Modification],
          }),
        );
      } else if (valuesAutoStorage && !params[FilterParams.MarkAuto] && !params[FilterParams.ModelAuto] && !params[FilterParams.YearAuto]) {
        dispatch(filterActions.setAuto({ key: fieldsAuto.Mark, value: params[FilterParams.MarkAuto] || valuesAutoStorage[fieldsAuto.Mark] }));
        dispatch(
          filterActions.setAuto({
            key: fieldsAuto.Model,
            value: params[FilterParams.ModelAuto] || valuesAutoStorage[fieldsAuto.Model],
          }),
        );
        dispatch(
          filterActions.setAuto({
            key: fieldsAuto.Year,
            value: params[FilterParams.YearAuto] || valuesAutoStorage[fieldsAuto.Year],
          }),
        );
        if (valuesAutoStorage[fieldsAuto.Modification]?.id == params[FilterParams.ModificationAuto]) {
          dispatch(
            filterActions.setAuto({
              key: fieldsAuto.Modification,
              value: valuesAutoStorage[fieldsAuto.Modification],
            }),
          );
        }
      }
      setIsLoaded(true);
    }
  }, []);

  useEffect(() => {
    if (isLoaded) {
      const filterParamsAuto = {
        mark: markCurrent !== paramAuto?.mark ? markCurrent : paramAuto?.mark,
        model: modelCurrent !== paramAuto?.model ? modelCurrent : paramAuto?.model,
        year: yearCurrent != paramAuto?.year ? yearCurrent : paramAuto?.year,
        modification: modificationCurrent !== paramAuto?.modification ? modificationCurrent : paramAuto?.modification,
      };
      handlerSetParamsLocalStorage(keyFilterLocalStorage, filterParamsAuto);
    }
  }, [markCurrent, modelCurrent, yearCurrent, modificationCurrent]);
};
